import React from "react";
import CandidateListCard from "./CandidateListCard";

export default function CandidateListPage() {
    return (
        <div className="container">
        <CandidateListCard />
        </div>
    );
}